import { render } from "./Properties.vue?vue&type=template&id=502968c1&scoped=true"
import script from "./Properties.vue?vue&type=script&lang=js"
export * from "./Properties.vue?vue&type=script&lang=js"

import "./Properties.vue?vue&type=style&index=0&id=502968c1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502968c1"]])

export default __exports__